import * as Yup from "yup";

import {
  ICreateAccountOptions,
  ICustomFieldsActive,
} from "shared/providers/context/initialStates/tenancy";

const getCustomFieldsSchema = (custom_fields: ICustomFieldsActive[]) => {
  let customFieldsSchema = Yup.object().shape({});

  custom_fields?.forEach((field) => {
    const newSchema = customFieldsSchema.concat(
      Yup.object().shape({
        [field?.name]: field?.required
          ? Yup.string().required("Campo obrigatório")
          : Yup.string(),
      }),
    );

    customFieldsSchema = newSchema;
  });

  return customFieldsSchema;
};

export const getInformationsSchemaValidation = (
  loggedUser: boolean,
  create_account_options: ICreateAccountOptions,
  country: string,
) => {
  let informationsSchema = Yup.object().shape({
    name: Yup.string()
      .matches(
        /^([a-zA-ZÀ-ÖØ-öø-ÿ]{2,}\s[a-zA-ZÀ-ÖØ-öø-ÿ]{2,}'?-?[a-zA-ZÀ-ÖØ-öø-ÿ]{0,}\s?([a-zA-ZÀ-ÖØ-öø-ÿ]{0,})?)/,
        "Digite nome e sobrenome",
      )
      .test(
        "last_name_min_length",
        "O sobrenome precisa ter no mínimo 2 caracteres",
        function (name) {
          const nameSplitted = name
            .split(" ")
            .filter(
              (name) => name !== "" && name !== undefined && name !== null,
            );

          const lastName = nameSplitted[nameSplitted?.length - 1];

          return lastName?.length >= 2;
        },
      )
      .required("Campo obrigatório"),

    document:
      country === "Brasil" &&
      Yup.string()
        .min(14, "No mínimo 11 caracteres")
        .max(18, "No máximo 14 caracteres")
        .required("Campo obrigatório"),
    phone_number: Yup.string()
      .min(5, "Campo obrigatório")
      .required("Campo obrigatório"),
  });

  if (
    !loggedUser &&
    create_account_options?.request_custom_fields_to_create_account
  )
    informationsSchema = informationsSchema.concat(
      getCustomFieldsSchema(create_account_options?.custom_fields_active),
    );

  if (loggedUser) return informationsSchema;

  return informationsSchema.concat(
    Yup.object().shape({
      email: Yup.string()
        .email("Digite um e-mail válido")
        .required("Campo obrigatório"),
    }),
  );
};
